// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__p7SeF","loadMoreButton":"styles_loadMoreButton__zcKlT","header":"styles_header__dmKl_","close":"styles_close__OGVer"};